module.exports = __webpack_public_path__ + "static/media/title.2bbfb3e0.svg";